export const agentRequestListParams = {
  page: "page",
  limit: "limit",
  search: "search",
  type: "criteria[type]",
  sender: "sender",
  sentBy: "criteria[sentBy]",
  quoteType: "criteria[quoteType]",
  status: "criteria[status]",
  createdAtFrom: "criteria[createdAtFrom]",
  createdAtTo: "criteria[createdAtTo]",
  quote: "criteria[quote]",
  location: "criteria[location]",
  // Label of the location chip only; never sent to the backend.
  locationName: "locationName",
};

export const agentRequestSender = {
  all: "all",
  mine: "mine",
} as const;
